import { useRef } from "react"

import { useDidMount } from "utils/customHooks"

export function useIsInitialRender() {
    const isInitialRender = useRef(true)
    useDidMount(() => {
        isInitialRender.current = false
    })
    return isInitialRender.current
}
